<template>
    <v-dialog v-model="dialog" max-width="600" @click:outside="hide">
        <v-card tile>
            <v-card-title>
                <v-icon color="black" left size="40">mdi-chart-box-outline</v-icon>
                <div class="title-dialog">
                    {{ editMode ? 'Editar' : 'Crear' }} Estado Financiero
                    <div class="title-subtext">
                        Completa los siguientes datos
                    </div>
                </div>
                <v-spacer />
                <v-btn icon color="accent" large @click="hide">
                    <v-icon large>mdi-close-circle-outline</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <!-- HEADERS INPUTS -->
                <v-row class="py-5">
                    <v-col cols="12" md="6">
                        <kimsa-text-field label="Cliente" outlined dense force-value :value="client" readonly
                            bolder-label />
                    </v-col>
                    <v-col cols="12" md="6">
                        <kimsa-text-field label="Año" outlined dense force-value :value="year" readonly bolder-label />
                    </v-col>
                    <v-col cols="12">
                        <kimsa-select label="Mes" placeholder="Selecciona un mes" bolder-label :items="months" outlined
                            solo flat dense item-text="name" item-value="value" force-value :value="month"
                            @change="month = $event" />
                    </v-col>
                </v-row>

                <v-row class="background-carousel">
                    <!-- INPUTS -->
                    <v-col cols="12">
                        <kimsa-file label="Documento" outlined dense @change="file = $event" placeholder="Seleccionar"
                            mimeType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />
                    </v-col>
                    <v-col cols="12" class="text-right">
                        <a :href="`${baseUrl}/samples/financials.xlsx`">
                            Descargar formato
                        </a>
                    </v-col>

                </v-row>

                <v-row class="pa-3">
                    <v-spacer />
                    <v-btn @click="finish" color="primary" depressed tile :disabled="!validSave" :loading="loading">
                        Guardar Estado Financiero
                    </v-btn>
                    <v-spacer />
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>

import * as XLSX from 'xlsx'
import { mapMutations, mapState } from "vuex";
import Axios from "@/utils/Axios";
import KimsaTextField from "@/components/common/inputs/KimsaTextField";
import KimsaFile from '../common/inputs/KimsaFile.vue';
import KimsaSelect from '../common/inputs/KimsaSelect.vue';

export default {
    name: "LoadFinancialExcelDialog",
    components: { KimsaTextField, KimsaFile, KimsaSelect },
    data() {
        return {
            dialog: false,
            loading: false,
            editMode: false,
            budgetId: null,
            financial: null,
            client: '',
            year: '',
            dollar: [],
            currentAssets: [],
            fixedAssets: [],
            otherAssets: [],
            currentLiabilities: [],
            longTermLiabilities: [],
            membersCapital: [],
            revenue: [],
            costSale: [],
            operatingExpenses: [],
            otherExpenses: [],
            template: { name: '' },
            file: null,
            months: [
                { name: 'Enero', value: 'january' },
                { name: 'Febrero', value: 'february' },
                { name: 'Marzo', value: 'march' },
                { name: 'Abril', value: 'april' },
                { name: 'Mayo', value: 'may' },
                { name: 'Junio', value: 'june' },
                { name: 'Julio', value: 'july' },
                { name: 'Agosto', value: 'august' },
                { name: 'Septiembre', value: 'september' },
                { name: 'Octubre', value: 'october' },
                { name: 'Noviembre', value: 'november' },
                { name: 'Diciembre', value: 'december' },
            ],
            month: null,
        }
    },
    computed: {
        ...mapState(['dialogActive']),
        validSave(vm = this) {
            return !!vm.client && !!vm.year && !!vm.file && !!vm.month
        },
        baseUrl() {
            return process.env.VUE_APP_BASE_URL || null
        },
    },
    async mounted() {
        const vm = this
    },
    methods: {
        ...mapMutations(['setDialogActive']),
        async show(payload) {
            const vm = this
            await vm.loadBasicInfo(payload)
            vm.dialog = true
            vm.setDialogActive(true)
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.setDialogActive(false)
            setTimeout(() => {
                vm.reset()
            }, 500)
        },
        reset() {
            const vm = this
            vm.editMode = false
            vm.budgetId = null
            vm.financial = null
            vm.client = ''
            vm.year = ''
            vm.dollar = []
            vm.currentAssets = []
            vm.fixedAssets = []
            vm.otherAssets = []
            vm.currentLiabilities = []
            vm.longTermLiabilities = []
            vm.membersCapital = []
            vm.revenue = []
            vm.costSale = []
            vm.operatingExpenses = []
            vm.otherExpenses = []
            vm.file = null
        },
        async loadBasicInfo(payload) {
            const vm = this
            vm.budgetId = payload.budgetId
            vm.client = payload.client
            vm.year = payload.year
            if (payload.financialId) {
                await vm.loadFinancial(payload.financialId)
            } else {
                vm.revenue = vm.takeAccountNames(payload.revenue)
                vm.costSale = vm.takeAccountNames(payload.costSale)
                vm.operatingExpenses = vm.takeAccountNames(payload.operatingExpenses)
                vm.otherExpenses = vm.takeAccountNames(payload.otherExpenses)
            }
        },
        takeAccountNames(array) {
            const vm = this
            return JSON.parse(JSON.stringify(array)).map(ar => {
                return { name: ar.name }
            })
        },
        async loadFinancial(id) {
            const vm = this
            await Axios.get(`financial-statement/${id}`).then(res => {
                // console.log('res loadFinancial', res)
                vm.financial = res.data.result.financialStatement
                vm.editMode = true
                vm.dollar = vm.financial.dollar
                vm.currentAssets = vm.financial.current_assets
                vm.fixedAssets = vm.financial.fixed_assets
                vm.otherAssets = vm.financial.other_assets
                vm.currentLiabilities = vm.financial.current_liabilities
                vm.longTermLiabilities = vm.financial.long_term_liabilities
                vm.membersCapital = vm.financial.members_capital
                vm.revenue = vm.financial.revenue
                vm.costSale = vm.financial.cost_sale
                vm.operatingExpenses = vm.financial.operating_expenses
                vm.otherExpenses = vm.financial.other_expenses
            }).catch(er => {
                console.log('error loadFinancial', er)
            })
        },
        async finish() {
            const vm = this
            vm.loading = true

            await vm.loadExcelValues()

            let payload = {
                budget_id: vm.budgetId,
                dollar: vm.dollar,
                current_assets: vm.currentAssets,
                fixed_assets: vm.fixedAssets,
                other_assets: vm.otherAssets,
                current_liabilities: vm.currentLiabilities,
                long_term_liabilities: vm.longTermLiabilities,
                members_capital: vm.membersCapital,
                revenue: vm.revenue,
                cost_sale: vm.costSale,
                operating_expenses: vm.operatingExpenses,
                other_expenses: vm.otherExpenses,
            }

            console.log('vm.editMode', vm.editMode);
            console.log('payload', payload)

            if (vm.editMode) return vm.editFinancial(payload)
            return vm.saveFinancial(payload)
        },
        loadExcelValues() {
            const vm = this;

            return new Promise((resolve, reject) => {
                const reader = new FileReader();

                reader.onload = (e) => {
                    try {
                        const excel = new Uint8Array(e.target.result);
                        const workbook = XLSX.read(excel, { type: 'array' });
                        vm.dollar = vm.mergeDollar(vm.dollar, vm.readSheet(workbook, 0))
                        vm.currentAssets = vm.mergeAccounts(vm.currentAssets, vm.readSheet(workbook, 1))
                        vm.fixedAssets = vm.mergeAccounts(vm.fixedAssets, vm.readSheet(workbook, 2))
                        vm.otherAssets = vm.mergeAccounts(vm.otherAssets, vm.readSheet(workbook, 3))
                        vm.currentLiabilities = vm.mergeAccounts(vm.currentLiabilities, vm.readSheet(workbook, 4))
                        vm.longTermLiabilities = vm.mergeAccounts(vm.longTermLiabilities, vm.readSheet(workbook, 5))
                        vm.membersCapital = vm.mergeAccounts(vm.membersCapital, vm.readSheet(workbook, 6))
                        vm.revenue = vm.mergeAccounts(vm.revenue, vm.readSheet(workbook, 7))
                        vm.costSale = vm.mergeAccounts(vm.costSale, vm.readSheet(workbook, 8))
                        vm.operatingExpenses = vm.mergeAccounts(vm.operatingExpenses, vm.readSheet(workbook, 9))
                        vm.otherExpenses = vm.mergeAccounts(vm.otherExpenses, vm.readSheet(workbook, 10))

                        resolve();
                    } catch (err) {
                        reject(err);
                    }
                };

                reader.onerror = reject;
                reader.readAsArrayBuffer(vm.file);
            });
        },
        mergeDollar(existing = [], incoming = {}) {
            if (!incoming || typeof incoming !== 'object') return existing;
            if (!existing.length) return [incoming];
            return [{ ...existing[0], ...incoming }];
        },
        mergeAccounts(existing = [], incoming = []) {
            const map = new Map();
            existing.forEach(item => {
                map.set(item.name, { ...item });
            });
            incoming.forEach(item => {
                if (!item?.name) return;

                if (map.has(item.name)) {
                    map.set(item.name, {
                        ...map.get(item.name),
                        ...item
                    });
                } else {
                    map.set(item.name, { ...item });
                }
            });

            return Array.from(map.values());
        },
        readSheet(workbook, sheetIndex) {
            const vm = this;
            const sheetName = workbook.SheetNames[sheetIndex];
            const worksheet = workbook.Sheets[sheetName];

            const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

            if (sheetIndex === 0) {
                const value = Number(rows?.[1]?.[0] || 0);
                return { [vm.month]: value };
            }

            const result = [];

            for (let rowIndex = 1; rowIndex < rows.length; rowIndex++) {
                const row = rows[rowIndex];
                if (!row || !row[0]) continue;

                result.push({
                    name: row[0],
                    [vm.month]: Number(row[1] || 0)
                });
            }

            return result;
        },
        async saveFinancial(payload) {
            const vm = this
            // console.log('saveFinancial', vm)

            await Axios.post('financial-statement/new', payload).then(res => {
                // console.log('res saveFinancial',res)
                vm.toast('Estado Financiero creado')
                vm.$emit('success')
            }).catch(error => {
                console.log('error saveFinancial', error)
            }).finally(() => {
                vm.loading = false
                vm.hide()
            })
        },
        async editFinancial(payload) {
            const vm = this
            // console.log('editFinancial', vm)

            await Axios.patch(`financial-statement/${vm.financial.id}/edit`, payload).then(res => {
                // console.log('res editFinancial',res)
                vm.toast('Estado Financiero actualizado')
                vm.$emit('success')
            }).catch(error => {
                console.log('error editFinancial', error)
            }).finally(() => {
                vm.loading = false
                vm.hide()
            })
        },
    },
    watch: {
        dialogActive(val) {
            if (!val) this.hide()
        },
    }
}
</script>

<style scoped>
.title-dialog {
    color: var(--v-primary-base);
    font-size: 20px;
    font-weight: bold;
    text-transform: uppercase;
}

.title-subtext {
    font-size: 11px;
    color: #a8a8a8;
    line-height: .5;
    text-transform: none;
    font-weight: normal;
}

.background-carousel {
    background-color: #f9f9f9;
    border-radius: 5px;
    border: 1px solid #efefef;
    padding: 10px;
    margin: 0;
}
</style>